import { Injector } from '@angular/core';
import { DRIVE_CONTEXT_MENUS } from './context-actions/drive-context-menus';
import { OverlayHandler } from './state/handlers/overlay-handler';
import { ToastHandler } from './state/handlers/toast-handler';
import { UploadPanelHandler } from './state/handlers/upload-panel-handler';
import { DialogHandler } from './state/handlers/dialog-handler';
import { ResetScrollHandler } from './state/handlers/reset-scroll-handler';
import { PageChangeHandler } from './state/handlers/page-change-handler';
import { PageLoadHandler } from './state/handlers/page-load-handler';
import { RemoveStarHandler } from './state/handlers/remove-star-handler';
export var STATE_HANDLERS = [
    OverlayHandler,
    ToastHandler,
    UploadPanelHandler,
    DialogHandler,
    ResetScrollHandler,
    PageChangeHandler,
    PageLoadHandler,
    RemoveStarHandler,
];
var ɵ0 = DRIVE_CONTEXT_MENUS, ɵ1 = function (settings) {
    var uploadInputConfig = { multiple: false };
    var extensions = settings.getJson('drive.validation.allowed_extensions');
    if (extensions) {
        uploadInputConfig.extensions = extensions.map(function (ext) { return '.' + ext; });
    }
    return uploadInputConfig;
};
var DriveModule = /** @class */ (function () {
    function DriveModule(injector) {
        var _this = this;
        this.injector = injector;
        STATE_HANDLERS.forEach(function (handler) { return _this.injector.get(handler); });
    }
    return DriveModule;
}());
export { DriveModule };
export { ɵ0, ɵ1 };
